import { useState, useEffect, useRef, useCallback } from 'react'
import apinode from '../../services/apinode.js'
import { toast } from 'react-toastify'

const DEBOUNCE_MS = 500

export default function AutocompleteClienteNode(props) {
  const [texto, setTexto] = useState('')
  const [lista, setLista] = useState([])
  const [loading, setLoading] = useState(false)
  const wrapRef = useRef(null)
  const timerRef = useRef(null)

  useEffect(() => {
    setTexto(props.value || '')
  }, [props.value])

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setLista([])
    }

    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const buscar = useCallback(async (valor) => {
    if (valor.length < 3) {
      setLista([])
      return
    }

    try {
      setLoading(true)

      const { data } = await apinode.get('/clientes', {
        params: { razao: valor, conta: localStorage.idconta },
      })

      if (data.length === 0) toast.warn('Nenhum cliente encontrado.')

      setLista(data)
    } catch {
      toast.error('Erro ao consultar clientes.')
    } finally {
      setLoading(false)
    }
  }, [])

  const handleChange = (e) => {
    const v = e.target.value
    setTexto(v)

    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => buscar(v), DEBOUNCE_MS)
  }

  const selecionar = (cli) => {
    setTexto(cli.PES_RAZAO)
    setLista([])
    props.onClickId(cli.COD_PESSOA)
    props.onClickNome(cli.PES_RAZAO)
    props.onClickCpf(cli.PES_CNPJ_CPF)
  }

  const limpar = () => {
    setTexto('')
    setLista([])
    props.onClickId(0)
    props.onClickNome('')
    props.onClickCpf('')
  }

  return (
    <div
      ref={wrapRef}
      style={{ position: 'relative', width: '100%' }}
    >
      <div style={{ position: 'relative' }}>
        <input
          type="text"
          className="form-control"
          placeholder={props.placeholder}
          value={texto}
          onChange={handleChange}
          autoComplete="off"
        />

        {loading && (
          <span style={iconStyle}>
            <span
              className="spinner-border spinner-border-sm text-secondary"
              style={{
                width: '1rem',
                height: '1rem',
              }}
            />
          </span>
        )}

        {!loading && texto && (
          <button
            style={{
              ...iconStyle,
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#9ca3af',
              fontSize: 16,
            }}
            onClick={limpar}
          >
            ✕
          </button>
        )}
      </div>

      {lista.length > 0 && (
        <div
          style={{
            position: 'absolute',
            top: 'calc(100% + 4px)',
            left: 0,
            right: 0,
            zIndex: 9999,
            backgroundColor: '#ffffff',
            border: '1px solid #d1d5db',
            borderRadius: 10,
            boxShadow: '0 8px 24px rgba(0,0,0,.18)',
            overflow: 'hidden',
            maxHeight: 280,
            overflowY: 'auto',
          }}
        >
          {lista.map((cli) => (
            <div
              key={cli.COD_PESSOA}
              onMouseDown={() => selecionar(cli)}
              style={{
                padding: '10px 14px',
                cursor: 'pointer',
                borderBottom: '1px solid #f3f4f6',
                backgroundColor: '#ffffff',
                transition: 'background .1s',
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.backgroundColor = '#f9fafb')
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.backgroundColor = '#ffffff')
              }
            >
              <div style={{ fontWeight: 500, fontSize: 14, color: '#111827' }}>
                {cli.PES_RAZAO}
              </div>
              <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                Cód: {cli.COD_PESSOA} · {cli.PES_CNPJ_CPF}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

const iconStyle = {
  position: 'absolute',
  right: 10,
  top: '50%',
  transform: 'translateY(-50%)',
  display: 'flex',
  alignItems: 'center',
}
